<template>
  <STermsAndConditions />
</template>

<script lang="ts">
import { getMetaInfo } from '@/utils/seo';

export default {
  name: 'TermsAndConditionsPage',
  metaInfo() {
    return getMetaInfo((this as { pageData?: { Seo?: unknown } }).pageData?.Seo);
  },
};
</script>

<script setup lang="ts">
import { STermsAndConditions } from '@slg/web-customer-shared';
</script>

<style lang="scss">
.terms-and-conditions-page-contaner {
  margin: 0 auto;
  min-height: 400px;
}
</style>
